/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {
  enableChangesAtom,
  slideShowAtom,
  projectsDataAtom,
  openSaveChangesDialogAtom,
  arrayChangesAtom,
} from '../Atoms';

export default function VerticalLinearStepper({ projectName }) {
  const slideShow = useRecoilValue(slideShowAtom);
  const enableChanges = useRecoilValue(enableChangesAtom);
  const openSaveChangesDialog = useRecoilValue(openSaveChangesDialogAtom);
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const setArrayChanges = useSetRecoilState(arrayChangesAtom);
  const [finishedStepsArray, setFinishedStepsArray] = useState([]);
  useEffect(() => {
    setFinishedStepsArray([]);
    setCurrentProjectData(projectsData.find((x) => x.Name === projectName && x.isCurrent === 1));
  }, [projectsData]);

  const intl = useIntl();
  const steps = [
    {
      label: 'RV1',
      description: `${intl.messages.RV1}`,
    },
    {
      label: 'RV2',
      description: `${intl.messages.RV2}`,
    },
    {
      label: 'RV3',
      description: `${intl.messages.RV3}`,
    },
    {
      label: 'RV4',
      description: `${intl.messages.RV4}`,
    },
    {
      label: 'RV5',
      description: `${intl.messages.RV5}`,
    },
    {
      label: 'RV6',
      description: `${intl.messages.RV6}`,
    },
    {
      label: 'RV7',
      description: `${intl.messages.RV7}`,
    },
  ];

  /**Returns the current step**/
  const getCurrentStep = (value) => {
    let index = 0;
    for (let i = 0; i < steps.length; i++) {
      if (steps[i].label.substring(0, 3) === value) {
        index = i + 1;
      }
    }
    if (index === 0) return 0;
    return index;
  };
  const [activeStep, setActiveStep] = useState(getCurrentStep(currentProjectData?.finishedPhase));
  const handleNext = () => {
    //next step
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setFinishedStepsArray((oldArray) => [...oldArray, activeStep + 1]);
  };

  const handleBack = () => {
    //previous step
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    const tmpFinishedStepsArray = [...finishedStepsArray];
    tmpFinishedStepsArray.pop();
    setFinishedStepsArray(tmpFinishedStepsArray);
  };

  /**When selected version change**/
  useEffect(() => {
    setActiveStep(getCurrentStep(currentProjectData?.finishedPhase));
  }, [currentProjectData]);

  useEffect(() => {
    if (openSaveChangesDialog) {
      const tmpArrayChanges = [];
      for (let i = 0; i < finishedStepsArray.length; i++) {
        if (finishedStepsArray[i]) {
          const step = {
            id: i === finishedStepsArray.length - 1 ? 'finishedPhase' : `phase${finishedStepsArray[i]}`,
            title: `RV${finishedStepsArray[i]}`,
            subtitle: intl.messages.COMPLETEDSTEP,
            value: finishedStepsArray[i],
          };
          tmpArrayChanges.push(step);
        }
      }
      setArrayChanges((oldArray) => [...oldArray, ...tmpArrayChanges]);
    }
  }, [openSaveChangesDialog]);
  return (
    <div>
      <Box sx={{ maxWidth: 400 }}>
        {slideShow ||
          (!enableChanges && (
            <Stepper activeStep={activeStep} orientation="vertical">
              <Step key={steps[activeStep].label}>
                <StepLabel>{steps[activeStep].label}</StepLabel>
                <Typography>{steps[activeStep].description}</Typography>
              </Step>
            </Stepper>
          ))}
        {!slideShow && enableChanges && (
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel>{step.label}</StepLabel>
                <StepContent>
                  <Typography>{step.description}</Typography>
                  <Box sx={{ mb: 2 }}>
                    <div>
                      <Button
                        variant="contained"
                        onClick={() => {
                          handleNext();
                        }}
                        sx={{ mt: 1, mr: 1 }}
                      >
                        {index === steps.length - 1 ? intl.messages.FINISH : intl.messages.CONTINUE}
                      </Button>
                      <Button
                        disabled={index === 0 || activeStep === getCurrentStep(currentProjectData?.finishedPhase)}
                        onClick={() => {
                          handleBack();
                        }}
                        sx={{ mt: 1, mr: 1 }}
                      >
                        {intl.messages.BACK}
                      </Button>
                    </div>
                  </Box>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        )}
      </Box>
    </div>
  );
}
